export default __webpack_public_path__ + "static/media/postman.96ecf7ba.svg";